import React from 'react';
import { Box } from '@mui/material';
import BrandSpinner from './BrandSpinner';

/**
 * Centred spinner.
 *
 * `fullScreen` is for the route guards, which run BEFORE the app shell exists —
 * there the viewport is the only frame available. Inside the content pane it must
 * not be used: 100vh there forces a scrollbar the page doesn't need, and swapping
 * a full-viewport empty box for real content moves everything twice. Pages with a
 * known shape should reach for a skeleton (see components/skeletons.js) instead of
 * this.
 */
const Loader = ({ fullScreen = false, minHeight = '55vh' }) => (
    <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        // 100dvh, not 100vh: on a phone 100vh is the height with the browser's
        // toolbars HIDDEN, so while they show the spinner sat half a toolbar
        // below the visible centre and the page gained a small scroll range.
        sx={fullScreen
            ? { height: '100vh', '@supports (height: 100dvh)': { height: '100dvh' } }
            : { minHeight }}
    >
        {/* The app's mark rather than the framework's default — see
            BrandSpinner. Fifteen screens reach this component, so the one
            substitution is most of "make the loaders look like ours". */}
        <BrandSpinner size={52} />
    </Box>
);

export default Loader;
